<div [ngStyle]="{ 'display' : rangeRingTool.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <form autocomplete="off"  id="ngRangeRingForm" [ngClass]="[this.rangeRingTool.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" name="ngRangeRingForm" #ngRangeRingForm="ngForm" id="rangeRingForm" style="height: 600px">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Coordenates</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Latitude</label>
            <div class="coordenates">
              <select  [(ngModel)]="rangeRingTool.latLonDms.latitude.cardinal"
            (ngModelChange)="rangeRingTool.latitude = rangeRingTool.latLonDms.toLat()
            " name="latCardSelect" style="width: 12%;">
                <option value="N">N</option>
                <option value="S">S</option>
              </select>
              <input name="latitudeDegrees"  [(ngModel)]="rangeRingTool.latLonDms.latitude.degrees
            "
            (ngModelChange)="
            rangeRingTool.latitude = rangeRingTool.latLonDms.toLat();
            " type="number" style="width: 24%;" />
                <span>º</span>
                <input  name="latMinutes"
                [(ngModel)]="
                rangeRingTool.latLonDms.latitude.minutes
                "
                (ngModelChange)="
                rangeRingTool.latitude = rangeRingTool.latLonDms.toLat();
                " type="number" style="width: 24%;" />
                <span>´</span>
                <input  name="latSeconds"
                [(ngModel)]="
                rangeRingTool.latLonDms.latitude.seconds
                "
                (ngModelChange)="
                rangeRingTool.latitude = rangeRingTool.latLonDms.toLat();
                " type="number" style="width: 24%;" />
                <span>"</span>
                <br/>
                <input [(ngModel)]="rangeRingTool.latitude" name="latitude" type="number" style="width: 93%; margin-top: 10px;" 
                      (ngModelChange)="rangeRingTool.latLonDms.fromLat(rangeRingTool.latitude)"/>
                <span>"</span>
            </div>
          </div>
          <div>
            <label for="">Longitude</label>
            <div class="coordenates">
              <select [(ngModel)]="rangeRingTool.latLonDms.longitude.cardinal"
              (ngModelChange)="rangeRingTool.longitude = rangeRingTool.latLonDms.toLon()
              " name="lonCardSelect" style="width: 12%;">
                <option value="W">W</option>
                <option value="E">E</option>
              </select>
              <input name="longitudeDegrees"  [(ngModel)]="rangeRingTool.latLonDms.longitude.degrees
              "
              (ngModelChange)="
              rangeRingTool.longitude = rangeRingTool.latLonDms.toLon();
              " type="number" style="width: 24%;" />
                <span>º</span>
                <input name="lonMinutes"
                [(ngModel)]="
                rangeRingTool.latLonDms.longitude.minutes
                "
                (ngModelChange)="
                rangeRingTool.longitude = rangeRingTool.latLonDms.toLon();
                " type="number" style="width: 24%;" />
                <span>´</span>
                <input name="lonSeconds"
                [(ngModel)]="
                rangeRingTool.latLonDms.longitude.seconds
                "
                (ngModelChange)="
                rangeRingTool.longitude = rangeRingTool.latLonDms.toLon();
                " type="number" style="width: 24%;" />
                <span>"</span>
                <br/>
                <input [(ngModel)]="rangeRingTool.longitude" name="longitude" type="number" style="width: 93%; margin-top: 10px;" 
                      (ngModelChange)="rangeRingTool.latLonDms.fromLon(rangeRingTool.longitude)"/>
                <span>"</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Parameters</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Start Ring</label>
            <div class="coordenates"><input name="startPoint" [(ngModel)]="rangeRingTool.start" type="number" style="width: 80%;" /><span>[NM]</span></div>
          </div>
          <div>
            <label for="">End Ring</label>
            <div class="coordenates"><input name="endPoint" [(ngModel)]="rangeRingTool.end" type="number" style="width: 80%;" /><span>[NM]</span></div>
          </div>
          <div>
            <label for="">Increment</label>
            <div class="coordenates"><input name="incrementPoint" [(ngModel)]="rangeRingTool.increments" type="number" style="width: 80%;" /><span>[NM]</span></div>
          </div>
          <div>
            <div class="btn" style="padding: 10px 10px 10px 0;">
              <button (click)="rangeRingTool.drawCircles();">Draw Range Ring</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
